export interface Unidad {
    id?: string,
    nombre: string,
    descripcion: string
}

export const defaultUnidad = { id: '', nombre: '', descripcion: '' };